import { UserModel } from '@app/src/views/Login/login/models/User';
import { LoginModelService } from '@app/src/views/Login/login/models/LoginService';
import { decodeJwt } from '../../helpers/decodeJwt';

export const hydrateUser = (data: LoginModelService): UserModel => {

  let user: UserModel['user'] = {
    id: 0,
    username: '',
    alias: '',
    isAdmin: false,
    isMultipleServices: false,
    accessToken: '',
    reportToken: '',
    service: {
      id: 0,
      name: '',
      idCountry: 0,
      dateCreated: ''
    }
  };

  if(data.data) {
    const payload = decodeJwt(data.data.accessToken)
    user.id = payload.userId;
    user.username = payload.user;
    user.alias = payload.alias;
    user.isAdmin = payload.role === 'admin';
    user.accessToken = data.data.accessToken;
    user.reportToken = data.data.reportToken;
    user.isMultipleServices = data.data.isMultipleServices;
    user.service.id = payload.serviceId;
    user.service.name = payload.service.service;
    user.service.idCountry = payload.service.countryId;
    user.service.dateCreated = payload.service.dateCreated;
  }

  const dataHydrate: UserModel = {
    code: data.code,
    message: data.message,
    user: user
  };

  return dataHydrate;
}
